export const REQUEST_LAST_CHANGES = "request_last_changes";
export const RECEIVE_LAST_CHANGES = "receive_last_changes";
export const LAST_CHANGES_ERROR = "last_changes_error";

export const REQUEST_PROCESS_OWNER = "request_process_owner";
export const RECEIVE_PROCESS_OWNER = "receive_process_owner";
export const PROCESS_OWNER_ERROR = "process_owner_error";

import { getLastChanges, getProcessOwner } from "src/actions/modelActions";

const getLastChangesRedux = modelId => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_LAST_CHANGES,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_LAST_CHANGES,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: LAST_CHANGES_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const audit = await getLastChanges(modelId);
			return onSuccess(audit);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};
const getProcessOwnerRedux = modelId => {
	return async dispatch => {
		const onRequest = () => {
			//dipatch request string to be handled by reducer
			dispatch({
				type: REQUEST_PROCESS_OWNER,
			});
		};
		const onSuccess = success => {
			dispatch({
				//dipatch receive string and payload to be handled by reducer
				type: RECEIVE_PROCESS_OWNER,
				payload: success,
			});
			return success;
		};
		const onError = error => {
			dispatch({
				//dipatch error string and payload to be handled by reducer
				type: PROCESS_OWNER_ERROR,
				payload: error,
			});
		};
		try {
			onRequest();
			//make api call
			const audit = await getProcessOwner(modelId);
			return onSuccess(audit);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};
};

export { getLastChangesRedux, getProcessOwnerRedux };
